<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Deals</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Deals
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Deals</h4>
                </div>

                <div class="card-body">
                    <list-controls
                        :search.sync="search"
                        search-id="deal-search"
                        placeholder="Search by deal name or description"
                        show-filters
                        @apply="applyFilters"
                        @reset="resetFilters"
                    >
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="deal-status">By Status</label>
                                <select id="deal-status" class="form-control form-control-sm" v-model="filters.status">
                                    <option :value="null">All</option>
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="deal-day">By Operating Day</label>
                                <select id="deal-day" class="form-control form-control-sm" v-model="filters.operating_day">
                                    <option :value="null">All</option>
                                    <option value="everyday">Everyday</option>
                                    <option v-for="day in daysOfWeek" :key="day.value" :value="day.value">
                                        {{ day.label }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </list-controls>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allDeals"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'image'">
                               <a :href="props.row.image" target="_blank">
                                   <img :src="props.row.image" :alt="props.row.name +' Image'"
                                        class="img-thumbnail img-fluid"
                                        style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">
                               </a>
                            </span>
                            <span v-else-if="props.column.field === 'status'">
                                <template v-if="props.row.status">
                                    <span class="badge badge-glow badge-success">Active</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">Inactive</span>
                                </template>
                            </span>
                            <span v-else-if="props.column.field === 'operating_day'">
                                <template v-if="props.row.operating_day">
                                    <span>{{props.row.operating_day.toUpperCase()}}</span>
                                </template>
                                <template v-else>
                                    <span>EVERYDAY</span>
                                </template>
                            </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <Link :href="route('admin.products.deals.edit', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </Link>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import ListControls from '@/Shared/ListControls';
import DeleteAlert from "../../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../../Shared/Mixins/PaginationMixin";
import ListQueryMixin from "../../../Shared/Mixins/ListQueryMixin";

export default {
    metaInfo: {title: 'Deals'},
    props: [
        'deals',
        'daysOfWeek',
    ],
    layout: Layout,
    name: 'DealIndex',
    components: {
        Link,
        ListControls,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        ListQueryMixin,
    ],
    data: () => ({
        filters: {
            status: null,
            operating_day: null,
        },
        baseUrl: window.location.origin,
        allDeals: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10,
            columnFilters: {},
        },

        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },

        sortingOptions: {
            enabled: false,
        },
        columns: [
            {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Deal Name', field: 'name', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Image', field: 'image', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Description', field: 'description', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Status', field: 'status', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Operating Day', field: 'operating_day', thClass: 'text-center', tdClass: 'text-center'},
            {
                label: 'Number of Free Products',
                field: 'free_product_quantity',
                thClass: 'text-center',
                tdClass: 'text-center'
            },
            {label: 'Deal Quantity', field: 'product_quantity', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
    }),
    mounted() {
        this.allDeals = this.deals.data;
        this.totalRecords = this.deals.total;
    },

    methods: {
        paginatedData() {
            return this.loadList('admin.products.deals.index', 'allDeals');
        },
        async deleteDeal(id) {
            this.$inertia.delete(route('admin.products.deals.delete', id), {
                preserveScroll: true,
                onSuccess: async () => {
                    await this.paginatedData();
                }
            })
        },

        async showAlert(dealId) {
            const details = {
                title: "Are you sure you want to delete this deal?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? this.deleteDeal(dealId) : "";
        },
    }
}
</script>
